import React, { Component } from 'react';
import { Spin, Icon } from 'antd';
import { ChangeName } from './Widget';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class PersonalInfo extends Component {
    state = {
        user: {},
        loading: false,
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { userId } = this.props;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.team.queryuser,
            data: { userId },
            dataType: 'json',
            doneResult: res => {
                const { user } = res;
                this.setState({
                    user,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    changeName = (name) => {
        this.changeNameRef.show(name);
    }

    render() {
        const { userId, isChinese,canEdit } = this.props;
        const {
            user: {
                userCompellation,
                enUserCompellation,
                enCityName,
                cityName,
                userEmail,
                userDetail,
                userMobile,
            },
            loading,
        } = this.state;
        const {
            name,
            gender,
        } = userDetail || {};
        return (
            <Spin spinning={loading}>
                <div style={{ marginBottom: 20 }}>
                    <table cellPadding='0' cellSpacing='0' className="distribute information">
                        <tbody>
                            <tr>
                                <td className="distribute_td_left need-bold">{isChinese ? "姓名" : "Name"}：</td>
                                <td className="distribute_td_right">
                                    {isChinese ? userCompellation : enUserCompellation}
                                    {!isChinese && canEdit && <a style={{marginLeft: 10}}><Icon type="edit" onClick={() => this.changeName(enUserCompellation)} /></a>}
                                </td>
                                <td className="distribute_td_left need-bold">{isChinese ? "性别" : "Gender"}：</td>
                                <td className="distribute_td_right">
                                    {
                                        isChinese ?
                                            gender === 'FEMALE' ? '女' : '男'
                                        :
                                            gender
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="distribute_td_left need-bold">{isChinese ? "工作城市" : "Location"}：</td>
                                <td className="distribute_td_right">{isChinese ? cityName : enCityName}</td>
                                <td className="distribute_td_left need-bold">{isChinese ? "手机号码" : "TEL"}：</td>
                                <td className="distribute_td_right">{userMobile}</td>
                            </tr>
                            <tr>
                                <td className="distribute_td_left need-bold">{isChinese ? "邮箱" : "E-mail"}：</td>
                                <td className="distribute_td_right">{userEmail}</td>
                            </tr>
                        </tbody>
                    </table>
                    <ChangeName ref={el => this.changeNameRef = el} userId={userId} loadData={this.loadData} />
                </div>
            </Spin>
        );
    }
}

export default PersonalInfo;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/PersonalInfo.js